import { Pipe, PipeTransform } from '@angular/core';
import { ItemSelectorRowItem } from '../interface';
import { getName as getCountryNameFromCode } from 'country-list';
import { TranslateService } from '@ngx-translate/core';

@Pipe({
  name: 'formatDisabledItem',
  pure: true,
})
export class FormatDisabledItemPipe implements PipeTransform {
  constructor(private translateService: TranslateService) {}

  transform(item: ItemSelectorRowItem, countryCode = '', context: Context): string {
    if (item.isSuspended) {
      return this.translateService.instant(this.translationPath(UnavailableItemType.SUSPENDED, context));
    }

    if (item.unavailableInCountry) {
      return this.translateService.instant(this.translationPath(UnavailableItemType.COUNTRY_RESTRICTION, context), {
        country: this.formatCountry(countryCode, context),
      });
    }

    if (item.isSelected && item.immutable) {
      return this.translateService.instant(this.translationPath(UnavailableItemType.ALREADY_ACTIVE, context));
    }

    return this.translateService.instant(this.translationPath(UnavailableItemType.DEFAULT, context));
  }

  translationPath(type: UnavailableItemType, context: Context) {
    const base = 'COMMON.UNAVAILABLE_ITEM';
    const contextPath = context === 'subtext' ? 'SUBTEXT' : 'TOOLTIP';
    return base + '.' + type + '.' + contextPath;
  }

  formatCountry(countryCode: string, context: Context) {
    if (context === 'tooltip') {
      return (
        getCountryNameFromCode(countryCode) ??
        this.translateService.instant('COMMON.UNAVAILABLE_ITEM.COUNTRY_RESTRICTION.COUNTRY_FALLBACK')
      );
    }
    return countryCode;
  }
}

export enum UnavailableItemType {
  SUSPENDED = 'SUSPENDED',
  COUNTRY_RESTRICTION = 'COUNTRY_RESTRICTION',
  ALREADY_ACTIVE = 'ALREADY_ACTIVE',
  DEFAULT = 'DEFAULT',
}

type Context = 'tooltip' | 'subtext';
